import { PUBLIC_CHAIN, PUBLIC_CONNECT_4337_COMETH_API_KEY } from '$env/static/public';
import { config, configChiado } from '$lib/constants/circlesV2Config';
import type { Address } from '$types/address';
import { SdkContractRunnerWrapper } from '@circles-sdk/adapter-ethers';
import { Sdk } from '@circles-sdk/sdk';
import { JsonRpcProvider } from 'ethers6';
import { gnosis, gnosisChiado } from 'viem/chains';
import { Cometh4337SdkContractRunner } from './cometh4337ContractRunner';
import { stateCirclesRpcEndpoint } from '$states/circlesRpcEndpoint.svelte';

export const connectComethToCirclesV2Sdk = async (address: Address) => {
  const circlesConfig =
    PUBLIC_CHAIN === 'GNOSIS'
      ? { ...config, circlesRpcUrl: stateCirclesRpcEndpoint.current }
      : configChiado;

  const jsonRpcProvider = new JsonRpcProvider(circlesConfig.circlesRpcUrl);

  const comethSdkContractRunner = new Cometh4337SdkContractRunner(
    PUBLIC_CONNECT_4337_COMETH_API_KEY,
    PUBLIC_CHAIN === 'GNOSIS' ? gnosis : gnosisChiado,
    address,
  );

  await comethSdkContractRunner.init();

  const createdWalletAddress = comethSdkContractRunner.address;

  if (!createdWalletAddress) {
    throw Error('No connected wallet address found');
  }

  const ethersContractRunner = new SdkContractRunnerWrapper(
    jsonRpcProvider,
    createdWalletAddress as Address,
    comethSdkContractRunner,
  );

  await ethersContractRunner.init();

  return new Sdk(ethersContractRunner, circlesConfig);
};
